import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css';
import { rubrosHistoricos70 } from '../../json/rubrosHistoricos70';

const RubrosHistoricos70 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Información histórica ejercicios anteriores Art. 70
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    rubrosHistoricos70.map((item, index) => (
                        <div key={ index } className='col-md-3 col-sm-6 col-12'>
                            <div className={styles.container}>
                                <h5 className={styles.name}>
                                    {item.descripcion}<br></br>
                                    {item.anio}
                                </h5>
                                <hr></hr>
                                {
                                    item.trimestres.map((trim, index) => (
                                        <div key={ index }>
                                            <a className={ styles.link } href={trim.url} target='_blank' rel='noopener noreferrer'>
                                                <div className={ styles.item }>
                                                    <p className={ styles.textLink }>
                                                        { trim.trimestre }
                                                    </p>
                                                    <i className={`icon-file-zip ${ styles.iconLink }`} aria-hidden="true"></i>
                                                </div>
                                            </a>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default RubrosHistoricos70